import { Howl } from 'howler';
let dropTickSource, positiveWinSoundSource, firstDropSource;
import { path } from "./settings.js";

export function loadSounds () {
  firstDropSource = new Howl({
    src: [path.audioPath + 'first-drop.wav'],
    volume: 1
  });

  dropTickSource = new Howl({
    src: [path.audioPath + 'progressive-tick.wav'],
    volume: 1
  });

  positiveWinSoundSource = new Howl({
    src: [path.audioPath + 'win-sound.wav'],
    volume: 1
  });

  console.log("Audio Loaded");
}

export function playFirstDropSound () {
  firstDropSource.play();
}

export function playDropTickSound () {
  dropTickSource.play();
}

export function playPositiveWinSound () {
  positiveWinSoundSource.play();
}

export function VolumeController (volume) {
  if(dropTickSource && positiveWinSoundSource && firstDropSource) {
    firstDropSource.volume(volume);
    dropTickSource.volume(volume);
    positiveWinSoundSource.volume(volume);
  }
}
